/**
 * Create button variables based on values from the button object
 * @param {object} button
 */
export default (button) => {
    const buttonTypes = [ 'regular', 'medium', 'small' ];

    const variables = {
        '--button-background': button.style.background.value,
        '--button-hover': button.style.hover.value,
        '--button-shadow': button.style.shadow.value,
        '--button-border': button.style.border.value,
    };

    for (const type of buttonTypes) {
        variables[`--${type}-button-border-shape`] = `var(--${type}-input-shape--${button.shape.value})`;
        variables[`--${type}-button-shadow-size`] = `var(--${type}-input-shadow-size--${button.shadow.value ? 'on' : 'off'})`;
        variables[`--${type}-button-border-width`] = `var(--${type}-input-border-width--${button.border.value})`;
    }

    return variables;
};
